import axios from '@api/axios';
import addressesService from '@api/addresses';

const axiosInstance = axios.create({
    baseURL: `/`
});

const logout = function() {
    return axiosInstance.post('logout');
};

const login = function(form) {
    return axiosInstance.post('login', form);
};

const csrf = function() {
    return axiosInstance.get('/airlock/csrf-cookie');
};

const register = function(form) {
    return axiosInstance.post('/api/register', { ...form, register: true });
};

const forgot = function(email) {
    return axiosInstance.post('/reset', { email: email });
};

const reset = function(form) {
    return axiosInstance.put('/reset/password', form);
};

const redirectToLogin = function(to, from, next) {
    if (!window.app.user) {
        next('/login');
    } else {
        next();
    }
};

const redirectToMain = function(to, from, next) {
    if (window.app.user) {
        next('/enquiries');
    } else {
        next();
    }
};

const user = window.app.user;
const can_manage = window.app.can_manage;

const toVue = function() {
    if (!user) {
        return null;
    }

    let userAddress = addressesService.defaultInput();

    if (user.address) {
        userAddress.line1 = user?.address?.line_1 || '';
        userAddress.line2 = user?.address?.line_2 || '';
        userAddress.postalCode = user?.address?.postal_code || '';
        userAddress.latitude = user?.address?.latitude || '';
        userAddress.longitude = user?.address?.longitude || '';
        userAddress.city = user?.address?.city || '';
        userAddress.county = user?.address?.county_id || '';
    }

    return {
        firstName: user?.first_name || '',
        lastName: user?.last_name || '',
        email: user?.email || '',
        password: '',
        confirmPassword: '',
        phoneNumber: user?.phone_number,

        address: userAddress
    };
};

export default {
    axios: axiosInstance,
    logout,
    login,
    register,
    csrf,
    redirectToLogin,
    redirectToMain,
    toVue,
    forgot,
    reset,
    user,
    can_manage
};
